package id.neotica.neotica.domain.model

data class ButtonData(
    val name: String,
    val url: String = "",
    val imageUrl: String = "",
)